export const formatIndianCurrency = (amount) => {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0, // Remove decimals, if needed
  }).format(amount);
};

export const setCurrentDate = () => {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, "0");
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const year = today.getFullYear(); // Full year, e.g. 2025

  return `${year}-${month}-${day}`; // Format: YYYY-MM-DD 
};

export const formatDate = (date) => {
  if (!date) return "";

  return new Date(date).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const truncateWords = (text, limit = 100) => {
  if (!text) return "";

  // 1. Remove extra quotes
  let cleanedText = text.replace(/\\"/g, "").replace(/"/g, "");

  // 2. Replace new lines & commas with space
  cleanedText = cleanedText.replace(/\n/g, " ").replace(/,/g, " ");

  // 3. Normalize spaces
  const words = cleanedText.trim().split(/\s+/);

  if (words.length <= limit) return cleanedText;

  return words.slice(0, limit).join(" ") + " ....";
};